import { Injectable } from '@angular/core';
import { WancomHttpService } from '../wancom-http/wancom-http.service';

@Injectable({
    providedIn: 'root',
})
export class AiGenerationService {
    url = 'imageGeneration';

    constructor(private http: WancomHttpService) {}

    public generate(prompt: string, numImage: number, photoRealism?:boolean, motor?: string) {
        return this.http.post<GeneratedImageInfo>(`${this.url}/Generate`, {
            prompt: prompt,
            numImage: numImage,
            PhotoReal:photoRealism,
            presetStyle: motor,
        });
    }

    public getGeneration(generatorId: string) {
        return this.http.get<GeneratedImageInfo>(
            `${this.url}/GetGeneration/${generatorId}`
        );
    }

    public saveGeneratedImage(
        id: number,
        mediaName: string,
        elmntType: number
    ) {
        let newGeneratedImageInput = new GeneratedImageInput();
        newGeneratedImageInput.elementType = elmntType;
        newGeneratedImageInput.fileName = mediaName;
        return this.http.post(
            `${this.url}/SaveGeneratedImage/${id}`,
            newGeneratedImageInput
        );
    }

    /**
     * Récupère le nombre de crédits de l'organisation de l'utilisateur
     *
     * @returns Le nombre de créddits de l'organisation
     */
    public getAICredit() {
        return this.http.get<number>(`${this.url}/getAiCredit`);
    }
}

export interface GeneratedImageInfo {
    generatorService: string;
    generatorId: string;
    generationStatus: string;
    links: GeneratedImageLink[];
}

export interface GeneratedImageLink {
    id: number;
    url: string;
}

export class GeneratedImageInput {
    fileName: string;
    elementType: number;
}
